import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import axios from '../../services/MyAxios';

import Card from 'crm/elements/common/Card';

export default function LotteryRuleTiers({ slug, url }) {
    const [ruleTiers, setRuleTiers] = useState([]);
    useEffect(() => {
        axios.get(url).then((response) => {
            setRuleTiers(response.data);
        });
    }, []);

    return (
        <Card title="Lottery Rule Tiers">
            {ruleTiers.map((tier, index) => (
                <Link
                    key={`tier_no_${index + 1}`}
                    className="btn btn-light btn-sm px-3 py-2 mr-2 mb-2 border rounded"
                    to={`/lotteries/${slug}/rule_tiers/${tier.id}`}
                >
                    {tier.name?.trim() || tier.slug}
                </Link>
            ))}
        </Card>
    );
}
